<template>
  <div>
    <!-- <div class="dldeing">设 置 新 密 码</div> -->
    <div class="hujisffs">
      <div class="dldeing" style="margin-bottom: 10px">
        {{ mobile }}
      </div>
      <div>您好，{{ name }}老师</div>
    </div>
    <div class="pin">
      <van-field
        v-model="code"
        style="margin-top: 10px"
        center
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
      >
        <template #button>
          <van-button size="mini" :class="time==59?'buttse':'huianhuse'" type="default" @click="fasong" style="width: 90px;">{{
            yanshe
          }}</van-button>
        </template>
      </van-field>
      <van-field
        label="新密码"
        type="password"
        v-model="value"
        placeholder="请输入新密码（6-20位英文或数字）"
        style="margin-top: 10px"
      />
      <van-field
        label="新密码"
        type="password"
        v-model="value1"
        placeholder="请再次输入新密码（6-20位英文或数字）"
        style="margin-top: 10px"
      />
      <div class="dlanniu" @click="dian">提 交</div>
    </div>
  </div>
</template>
<script>
import { userpassword,aliyunSmssendSmsCode,usermodifyPasswordByCode } from "@/api/home";
import { Toast } from "vant";
export default {
  data() {
    return {
      value: "",
      value1: "",
      name: this.$route.query.name,
      userId: this.$route.query.userId,
      fromPath: "",
      mobile: this.$route.query.mobile,
      code: "",
      yanshe: "发送验证码",
      time: 59,
      timer: "",
    };
  },
  watch: {},
  components: {},
  methods: {
    dian() {
      if (this.value == "" || this.value1 == "") {
        Toast("请输入新密码");
        return false;
      }
      if (this.value !== this.value1) {
        Toast("两次密码不一致，请重新输入");
        return false;
      }
      if (this.value.length < 6) {
        Toast("新密码为6-20位英文或数字！");
        return false;
      }
      let that = this;
      let params = {
        roleType: "teacher",
        userId: this.userId,
        code: this.code,
        password: this.value,
      };
      usermodifyPasswordByCode(params)
        .then((res) => {
          if(res.data.code=='0'){
            Toast("修改成功,请重新登录");
            setTimeout(function () {
              that.$router.push({
                path: "/log",
              });
            }, 2000);
          }else{
            Toast(res.data.msg);
          }
        })
        .catch((rdd) => {});
    },
    fasong() {
      let that = this;
      let params = {
        types: "teacher",
        mobile: this.mobile,
      };
      if (that.time == 59) {
        aliyunSmssendSmsCode(params)
          .then((res) => {
              that.timer = setInterval(() => {
                if (that.time > 0) {
                  that.time--;
                  that.yanshe=that.time+'s'
                } else {
                  clearInterval(that.timer);
                  that.yanshe='重新发送'
                  that.time = 59;
                }
              }, 1000);
          })
          .catch((rdd) => {});
        }
    },
  },
  mounted() {},
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/my/newpassword.vue